export enum License {
	Primobox = "TALENT_BSE",
	Inwink = "INWINK",
	Ideta = "IDETA"
}



// WEBPACK FOOTER //
// ./src/shared/Enums/Licensing/License.ts